import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/sonner";
import "@/lib/sound";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Cursos from "@/pages/Cursos";
import CursoDetalhe from "@/pages/CursoDetalhe";
import Instrucoes from "@/pages/Instrucoes";
import Turmas from "@/pages/Turmas";
import TurmaDetalhe from "@/pages/TurmaDetalhe";
import Oficinas from "@/pages/Oficinas";
import OficinaDetalhe from "@/pages/OficinaDetalhe";
import ModelosFicha from "@/pages/ModelosFicha";
import Alunos from "@/pages/Alunos";
import AlunoDetalhe from "@/pages/AlunoDetalhe";
import Avaliar from "@/pages/Avaliar";
import AvaliarPad from "@/pages/AvaliarPad";
import AplicacaoPainel from "@/pages/AplicacaoPainel";
import Avaliacoes from "@/pages/Avaliacoes";
import AvaliacaoDetalhe from "@/pages/AvaliacaoDetalhe";
import Register from "@/pages/Register";
import Instrutores from "@/pages/Instrutores";
import Inscricao from "@/pages/Inscricao";
import Formativa from "@/pages/Formativa";
import FormativaPad from "@/pages/FormativaPad";
import FormativaConsolidado from "@/pages/FormativaConsolidado";
import FormativaModelo from "@/pages/FormativaModelo";
import PraticaConsolidado from "@/pages/PraticaConsolidado";
import Ocorrencias from "@/pages/Ocorrencias";
import Biblioteca from "@/pages/Biblioteca";
import Configuracoes from "@/pages/Configuracoes";
import RelatoriosInstrutores from "@/pages/RelatoriosInstrutores";
import CapacitadosConsolidado from "@/pages/CapacitadosConsolidado";
import Resultados from "@/pages/Resultados";
import LimpezaAdmin from "@/pages/LimpezaAdmin";
import { SplashScreen } from "@/components/SplashScreen";
import { OfflineBanner } from "@/components/OfflineBanner";
import { ForcePasswordChange } from "@/components/ForcePasswordChange";

const P = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function AppRoutes() {
  const location = useLocation();
  return (
    <ErrorBoundary resetKey={location.pathname}>
      <Routes location={location}>
        <Route path="/login" element={<Login />} />
        <Route path="/registrar" element={<Register />} />
        <Route path="/inscricao/:token" element={<Inscricao />} />
        <Route path="/instrutores" element={<ProtectedRoute adminOnly><Instrutores /></ProtectedRoute>} />
        <Route path="/" element={<P><Dashboard /></P>} />
        <Route path="/cursos" element={<P><Cursos /></P>} />
        <Route path="/cursos/:id" element={<P><CursoDetalhe /></P>} />
        <Route path="/instrucoes" element={<P><Instrucoes /></P>} />
        <Route path="/instrucoes/:id" element={<P><CursoDetalhe /></P>} />
        <Route path="/turmas" element={<P><Turmas /></P>} />
        <Route path="/turmas/:id" element={<P><TurmaDetalhe /></P>} />
        <Route path="/oficinas" element={<P><Oficinas /></P>} />
        <Route path="/oficinas/:id" element={<P><OficinaDetalhe /></P>} />
        <Route path="/modelos" element={<P><ModelosFicha /></P>} />
        <Route path="/alunos" element={<P><Alunos /></P>} />
        <Route path="/alunos/:id" element={<P><AlunoDetalhe /></P>} />
        <Route path="/avaliar" element={<P><Avaliar /></P>} />
        <Route path="/avaliar/:id" element={<P><AvaliarPad /></P>} />
        <Route path="/aplicacao/:turmaId/:oficinaId" element={<P><AplicacaoPainel /></P>} />
        <Route path="/avaliacoes" element={<P><Avaliacoes /></P>} />
        <Route path="/avaliacoes/:id" element={<P><AvaliacaoDetalhe /></P>} />
        <Route path="/formativa" element={<P><Formativa /></P>} />
        <Route path="/formativa/avaliar/:id" element={<P><FormativaPad /></P>} />
        <Route path="/formativa/consolidado/:turmaId" element={<P><FormativaConsolidado /></P>} />
        <Route path="/formativa/modelo" element={<ProtectedRoute adminOnly><FormativaModelo /></ProtectedRoute>} />
        <Route path="/pratica/consolidado/:turmaId/:oficinaId" element={<P><PraticaConsolidado /></P>} />
        <Route path="/ocorrencias" element={<P><Ocorrencias /></P>} />
        <Route path="/biblioteca" element={<P><Biblioteca /></P>} />
        <Route path="/configuracoes" element={<P><Configuracoes /></P>} />
        <Route path="/relatorios" element={<P><RelatoriosInstrutores /></P>} />
        <Route path="/capacitados" element={<P><CapacitadosConsolidado /></P>} />
        <Route path="/resultados" element={<P><Resultados /></P>} />
        <Route path="/limpeza" element={<ProtectedRoute adminOnly><LimpezaAdmin /></ProtectedRoute>} />
      </Routes>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <AuthProvider>
      <OfflineBanner />
      <SplashScreen />
      <ForcePasswordChange />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </AuthProvider>
  );
}

export default App;
